<template>
  <div class="MyloadSwipeItem">
    <div class="swipeItem_head">
      <div>
        <span class="swipeItem_head_text">{{ productName }}</span>
        <!-- <span class="increaseAmount" v-if="result.productId === 'SPDB-FPD' && result.contractStatus === '额度生效'" @click="increaseAmount">提额</span> -->
      </div>
      <div class="tag" v-if="result.aggsProductName">{{ result.aggsProductName }}</div>
      <!-- <div class="swipeItem_head_text">
        <span class="swipeItem_head_text_font">{{ current + 1 }}</span><span class="swipeItem_head_text_font_color">/{{ maxLength }}</span>
      </div> -->
    </div>
    <div class="swipeItem_box">
      <div class="swipeItem_left">
        <svg-circle
          :current="current"
          :loanableAmount="loanableAmount"
          :creditAmount="result.creditAmount"
        ></svg-circle>
        <div class="loanableAmount">
          <div>可贷额度</div>
          <div>{{ loanableAmount }}元</div>
        </div>
      </div>
      <div class="swipeItem_right">
        <div class="swipeItem_right_left">
          <div class="separate">
            <div class="fontStatus">授信合同状态</div>
            <div class="separateVal">{{ result.contractStatus || '--' }}</div>
          </div>
          <div class="separate">
            <div class="fontStatus">累计提款</div>
            <div class="separateVal">{{ result.withDrawn || '--'  }}</div>
          </div>
          <div class="zemoStyle">
            <div class="fontStatus">申请时间</div>
            <div class="separateVal">{{ result.orderTime || '--'}}</div>
          </div>

        </div>

        <div>
          <div class="separate">
            <div class="fontStatus">授信期限</div>
            <div class="separateVal">{{ result.creditTerm || '--'  }}</div>
          </div>
          <div class="separate">
            <div class="fontStatus">授信总额</div>
            <div class="separateVal">{{ result.creditAmount || '--'  }}</div>
          </div>

          <div class="yearsRate">
            <div class="fontStatus">年利率</div>
            <div class="separateVal">{{ result.execRate?`${ parseFloat(result.execRate).toFixed(2)} %` : '--' }}</div>
          </div>
        </div>

      </div>
    </div>

    <button
      :disabled="isDisabled"
      class="disabledStlye"
      :class="{ active: !isDisabled }"
      @click="nextStep"
    >
      立即提款
    </button>
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant';
import SvgCircle from './SvgCircle.vue';

export default {
  name: 'MyloadSwipeItem',
  components: {
    SvgCircle,
  },
  data() {
    return {
      result: {},
    };
  },
  props: {
    current: {
      type: Number,
      default: 0,
    },
    maxLength: {
      type: Number,
      default: 0,
    },
    creditSucceinfo: {
      type: Object,
    },
  },
  computed: {
    isDisabled() {
      let flag = true;
      const {
        productId,
        usableAmount,
        withdrawButton,
      } = this.result;
      if (productId === 'SPDB-FPD'
        ) {
        return false;
      }
      if( productId === 'WZ_WYDCJ'
        || productId === 'NBYH-RYD'
        || productId === 'XWBANK-TAX'
        || productId === 'SN-WSD'
        || productId === 'DXM-QYD'){
          return true
        }
      if (
        productId !== 'PINGAN-FPD'
        && productId !== 'DASHU-FPD'
        && productId !== 'DASHU-FPD'
        && productId !== 'DS-PH'
        && productId !== 'PINGAN-SPD'
        && productId !== 'XDL-LSD'
        && productId !== 'LX-FPD'
        && productId !== 'LX-SD'
        && productId !== 'FD-WSD'
        && productId !== 'MS-ZWD'
        && productId !== 'DASHU-YWD'
        && productId !== 'SN-FPD'
        && productId !== 'SPDB-PHD'
        && productId !== 'PINGAN-XWD'
        && productId !== 'YX-FPD'
        && productId !== 'SPDB-YQD'
        && productId !== 'PINGAN-XWDXS'
        && productId !== 'XMGJ-FPD'
        && productId !== 'DASHU-PLUS'
        && productId !== 'SN-CGD'
        && productId !== 'PF-PWD'
        && productId !== 'JSSN-FPD'
        && productId !== 'BR-RSD'
        && productId !== 'XYD-FPD'
        && productId !== 'BR-QYZD'
        && productId !== 'WC-HFQ'
      ) {
        console.log(flag, 'flag', withdrawButton);
        // eslint-disable-next-line no-unused-expressions
        parseFloat(usableAmount || 0) <= 0 ? (flag = true) : (flag = false);
      } else {
        // eslint-disable-next-line no-unused-expressions
        withdrawButton ? (flag = false) : (flag = true);
      }
      return flag;
    },
    loanableAmount() {
      const { usableAmount } = this.result;
      const val = usableAmount || 0;
      return val;
    },
    productName() {
      const {
        productName,
      } = this.result;
      console.log(productName, 'productName');
      return productName;
    },
  },
  watch: {
    creditSucceinfo: {
      handler(newVal) {
        console.log('newVal', newVal);

        this.result = newVal;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async nextStep() {
      const { orderId, productId } = this.result;
      // eslint-disable-next-line no-unused-expressions
      orderId && localStorage.setItem('orderId', orderId);
      // eslint-disable-next-line no-unused-expressions
      productId && localStorage.setItem('productid', productId);
      // 跳转不同的入口
      if (orderId === 'ICBC-SWD') {
        this.$dialog.alert({
          title: '提示',
          message: '请下载并登录工商银行融e行app，进入“经营快贷”页面进行提款。',
        });
        return;
      }
      // 翰华 是否可提额 {"flag":"0:不弹窗，1:翰华弹窗", "message":"弹窗话术"}
      const { success, data: { flag, message, type } } = await this.$api.PublicPage.preJumpCurrPage({ orderId });
      if (success && flag === '1') {
        if(type=='1'){ // 继续提款弹窗
          Dialog.confirm({
            title: '提示',
            message,
            confirmButtonText: '继续提款',
            cancelButtonText: '暂不提款',
          }).then(() => {
            this.jumpTheThirdPartyAddress();
          });
        }else{ // 确认弹窗
          this.$dialog.alert({
            title: '提示',
            message
          });
        }
        return;
      }

      this.jumpTheThirdPartyAddress();
    },
    // 提额
    // async increaseAmount() {
    //   const { orderId } = this.result;
    //   this.$loading.show('加载中...');
    //   const res = await this.$api.PublicPage.getCreditUpdate({
    //     orderId,
    //   });
    //   this.$loading.hide();
    //   Toast({
    //     message: res.returnMessage,
    //     forbidClick: true, // 背景不可点击
    //   });
    // },
    jumpTheThirdPartyAddress() {
      const { orderId } = this.result;
      this.$api.PublicPage.jumpCurrPage({ orderId })
        .then((res) => {
          if (res.success) {
            if (res.data) {
              window.location.href = res.data;
            }
          } else {
            this.$dialog.alert({
              title: '提示',
              message: '操作失败',
            });
          }
        })
        .catch((e) => {
          this.$dialog.alert({
            title: '提示',
            message: e,
          });
        });
    },
  },
};
</script>
<style scoped>
.MyloadSwipeItem >>> .van-swipe.van-swipe__indicators {
  display: none !important;
}
.MyloadSwipeItem {
  padding: 8px;
  background-color: white;
}
.swipeItem_head {
  display: flex;
  justify-content: start;
  margin-bottom: 8px;
  align-items: center;
}
.swipeItem_box {
  display: flex;
}
.swipeItem_left {
  position: relative;
  margin-right: 8px;
}
.swipeItem_right {
  flex: 1;
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: left;
}
.swipeItem_right_left {
  min-width: 100px;
}
.separate {
  margin-bottom: 10px;
}
.separateVal {
  font-family: PingFangSC-Regular;
  color: #1c2438;
  font-size: 12px;
  white-space: nowrap;
}
.fontStatus {
  font-family: PingFangSC-Regular;
  color: #b7bfd2;
  font-size: 12px;
}
.swipeItem_footer {
  width: 95%;
  height: 40px;
  border: 1px solid #f56446;
  margin: 0 auto;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #f56446;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  margin-top: 16px;
}
.swipeItem_head_text {
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #1c2438;
}
.increaseAmount {
  margin-left: 30px;
  font-size: 16px;
  color: #f56446;
}
.swipeItem_head_text_font {
  font-weight: bold;
  font-size: 18px;
  font-family: PingFangSC-Regular;
}
.swipeItem_head_text_font_color {
  color: #b7bfd2;
  font-weight: 400;
}
.loanableAmount {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #f56446;
  font-size: 12px;
}
.disabledStlye {
  width: 100%;
  height: 40px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  border-radius: 8px;
  color: #bbbbbb;
  background: #e8e8e8;
  border: 0;
  margin-top: 10px;
  margin-bottom: 10px;
}
.active {
  color: #f56446;
  border: 1px solid #f56446;
  background: #fff;
}
.yearsRate {
  /* position: absolute;
  top: 180px;
  left: 156px;
  text-align: left; */
  /* margin-left: 15px;
  margin-bottom: 16px; */
}
.zemoStyle {
  height: 34px;
}
.tag{
  color: #ff6538;
  font-size: 12px;
  padding: 2px;
  background-color: rgba(255, 101, 56, .1);
  margin-left: 8px;
}
</style>
